import axios from "axios";
import { API_BASE_URL } from "../../constants";

export default class MailerService {
    constructor() {
        this.resource = `${API_BASE_URL}/mailer_setting`;
    }

    static getInstance() {
        if (!MailerService.instance) {
            MailerService.instance = new MailerService();
        }

        return MailerService.instance;
    }

    async fetchMailerSettings() {
        const response = await axios.get(`${this.resource}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        return response.data.data;
    }


    async saveMailerSettings(settings) {
        const response = await axios.post(`${this.resource}/edit`, settings, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    }

    async toggleMailerActivation(isActive) {
        const response = await axios.post(
            `${this.resource}/toggle_active`,
            { isActive },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    async testConnection(payload) {
        const response = await axios.post(
            `${this.resource}/validate`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
        return response.data;
    }
}
